import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import tPsSelectors from '../../store/training-programs/selectors';
import trainingProgramsActionCreators from '../../store/training-programs/action-creators';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import TrainingProgramEdit from './TrainingProgramEdit';
import TrainingPhaseEdit from './TrainingPhaseEdit';
import TrainingPhaseDetailCard from './TrainingPhaseDetailCard';
import Modal from "../../../shared/ui/Modal";
import TrainingProgramAddPhase from "./TrainingProgramAddPhase";
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import SignFlowManage from "./SignFlowManage";


const SortablePhase = SortableElement(({elementIndex, phase, getTrainingPhaseCardActionsFor, deletePhase, editPhase, showActions}) => (
  <TrainingPhaseDetailCard
    actions={getTrainingPhaseCardActionsFor(phase, elementIndex)}
    onDelete={() => deletePhase(elementIndex)}
    onEdit={() => editPhase(elementIndex)}
    phase={phase}
    showActions={showActions}
  />
));

const SortableTrainingPhases = SortableContainer(({phases, getTrainingPhaseCardActionsFor, deletePhase, editPhase, showActions}) => (
  <div>
    {phases.map((phase, index) =>
      <SortablePhase
        index={index}
        elementIndex={index}
        disabled={phase.type === 'orientation'}
        phase={phase}
        key={'item-' + index}
        getTrainingPhaseCardActionsFor={getTrainingPhaseCardActionsFor}
        deletePhase={deletePhase}
        editPhase={editPhase}
        showActions={showActions}
      />
    )}
  </div>
));

class TrainingProgramDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultPhases: {
        observation: {
          header: 'New Observation Phase',
          forms: [
            {
              key: 'dor',
              min: 20,
              required: true,
            },
            {
              key: 'wor',
              min: 4,
              required: true,
            },
          ],
          type: 'observation',
          weeks: 4,
        },
        orientation: {
          header: 'Orientation',
          forms: [
            {
              key: 'tpo',
              min: 1,
              required: true,
            }
          ],
          type: 'orientation',
        },
      },
      dropdownOpen: false,
      isEditingPhase: null,
      newPhaseInitialValues: {},
      tempPlan: null
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    if (this.props.match.params.trainingProgramGuid !== this.props.selectedGuid) {
      this.props.setSelectedTPGuid(this.props.match.params.trainingProgramGuid);
    }
  }

  // ----------------------
  // Computed
  // ----------------------

  get hasOrientation() {
    return this.props.selectedTP.plan[0].type === 'orientation';
  }

  get isLoading() {
    return !this.props.selectedTP || this.props.isLoading.includes('fetchTrainingPrograms');
  }

  getPhase(index) {
    return this.props.selectedTP.plan[index];
  }

  getTrainingPhaseCardActionsFor(phase, index) {

    return this.props.selectedTP.status === 'draft' ? {
      canDelete: this.props.selectedTP.plan.length > 1,
      canEdit: true,
      canMove: phase.type !== 'orientation',
    } : {
      canDelete: false,
      canEdit: this.props.userContext.hasScope(['admin', 'depadmin']),
      canMove: false
    };
  }

  get canEdit() {
    return this.props.selectedTP.status === 'draft'
  }

  get canEditSignFlow() {
    return this.props.selectedTP.status === 'draft' || (this.props.selectedTP.status ==='current' && this.props.userContext.hasScope(['admin', 'depadmin']))
  }
  // ----------------------
  // Methods
  // ----------------------

  addObservationPhase() {
    this.props.addNewPhase();
    this.setState({
      newPhaseInitialValues: Object.assign({}, this.state.defaultPhases.observation) //clone the object
    });
  }

  addOrientationPhase() {
    this.props.addNewPhase();
    this.setState({
      newPhaseInitialValues: Object.assign({}, this.state.defaultPhases.orientation) //clone the object
    });
  }

  addNewPhase({formData, addAfterPhase}) {
    const plan = addAfterPhase !== null ? [
      ...this.props.selectedTP.plan.slice(0, addAfterPhase + 1),
      formData,
      ...this.props.selectedTP.plan.slice(addAfterPhase + 1),
    ] : [
      formData,
      ...this.props.selectedTP.plan
    ];

    this.props.updateTP(this.props.selectedGuid, {plan})
      .then(() => this.props.closeAddNewPhase());
  }

  updateSignFlow(signFlow) {
    this.props.updateTP(this.props.selectedGuid, {
      description: this.props.selectedTP.description,
      title: this.props.selectedTP.title,
      type: this.props.selectedTP.type,
      signFlow
    });
  }

  closeEditPhase() {
    this.setState({isEditingPhase: null});
  }

  deletePhase(index) {
    const plan = [...this.props.selectedTP.plan];
    plan.splice(index, 1);
    this.props.updateTP(this.props.selectedGuid, {plan});
  }

  editPhase(index) {
    this.setState({isEditingPhase: index});
  }

  reIndexPlan(oldIndex, newIndex) {
    const plan = [...this.props.selectedTP.plan];
    const moving = plan.splice(oldIndex, 1);
    plan.splice(newIndex, 0, moving[0]);

    this.setState({
      tempPlan: plan
    });

    this.props.updateTP(this.props.selectedGuid, {plan})
      .then(() => {
        this.setState({
          tempPlan: null
        });
      });
  }

  updatePhase(formData) {
    const index = this.state.isEditingPhase;
    const plan = [...this.props.selectedTP.plan];
    plan[index] = formData;
    this.props.updateTP(this.props.selectedGuid, {plan});
    this.setState({isEditingPhase: null});
  }

  onSortEnd({oldIndex, newIndex}) {
    if (oldIndex !== newIndex) {
      this.reIndexPlan(oldIndex, newIndex);
    }
  };

  // ----------------------
  // State setters
  // ----------------------

  toggle() {
    this.setState({dropdownOpen: !this.state.dropdownOpen});
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        <Fragment>
          {!this.isLoading &&
          <Fragment>

            <div className="app-content-header">
              <h1 className="title">{this.props.selectedTP.title}
                <span className={"badge badge-" + (this.props.selectedTP.status === 'revised' ? 'primary' : 'secondary')}>
                  {this.props.selectedTP.status}
                </span>
              </h1>

              <div className="header-right-content">
                {this.props.userContext.hasScope(['depadmin', 'admin']) &&

                <Fragment>
                  {

                    this.props.selectedTP.status === 'draft' &&
                    <button className="button secondary small" onClick={this.props.editTP}>
                      <i className="fa fa-edit"/> Edit
                    </button>
                  }

                  {this.props.selectedTP.status === 'draft' &&

                  <Fragment>
                    {!this.hasOrientation &&
                    <button className="button primary small" onClick={() => this.addOrientationPhase()}>
                      <i className="fa fa-plus"> </i> Add Orientation Phase
                    </button>
                    }
                    <button className="button primary small" onClick={() => this.addObservationPhase()}>
                      <i className="fa fa-plus"> </i> Add Observation Phase
                    </button>
                  </Fragment>
                  }
                </Fragment>
                }
              </div>
            </div>

            <div className="app-content timeline">
              <SignFlowManage
                onChange={(signFlow => this.updateSignFlow(signFlow))}
                canEdit={this.canEditSignFlow}
                signFlow={this.props.selectedTP.signFlow}
                formTypes={this.props.formTypes}
              />
              <div className='card timeline-header'>

                <div className='timeline-details-desc'>
                  <span className='label'>Type</span>
                  {this.props.selectedTP.type}
                </div>

                <div className='timeline-details-desc'>
                  <span className='label'>Description</span> {this.props.selectedTP.description}
                </div>

              </div>
              <div>
                <SortableTrainingPhases
                  lockAxis={'y'}
                  lockToContainerEdges
                  useDragHandle
                  onSortEnd={this.onSortEnd.bind(this)}
                  helperClass={'drag-active'}
                  phases={this.state.tempPlan || this.props.selectedTP.plan}
                  getTrainingPhaseCardActionsFor={this.getTrainingPhaseCardActionsFor.bind(this)}
                  deletePhase={this.deletePhase.bind(this)}
                  editPhase={this.editPhase.bind(this)}
                  showActions={this.props.userContext.hasScope(['depadmin', 'admin'])}
                />
              </div>
            </div>

            <Modal
              isOpen={this.props.isEditingTP}
              title="Edit Training Program"
              onClose={() => this.props.closeEditTP()}>
              <TrainingProgramEdit/>
            </Modal>

            <Modal
              isOpen={this.state.isEditingPhase !== null}
              onClose={() => this.closeEditPhase()}
              title="Edit Phase">
              <TrainingPhaseEdit
                onUpdate={formData => this.updatePhase(formData)}
                phase={this.getPhase(this.state.isEditingPhase)}
              />
            </Modal>

            <Modal
              isOpen={this.props.isAddingNewPhase}
              onClose={() => this.props.closeAddNewPhase()}
              title="Add new Phase">
              <TrainingProgramAddPhase
                onUpdate={data => this.addNewPhase(data)}
                trainingProgram={this.props.selectedTP}
                phase={this.state.newPhaseInitialValues}
              />
            </Modal>

          </Fragment>
          }


          {/*{this.state.isEditingPhase !== null &&*/}
          {/*<TrainingPhaseEdit*/}
          {/*onClose={() => this.closeEditPhase()}*/}
          {/*onUpdate={formData => this.updatePhase(formData)}*/}
          {/*phase={this.getPhase(this.state.isEditingPhase)}*/}
          {/*/>*/}
          {/*}*/}

        </Fragment>
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isEditingTP: !!state.trainingPrograms.isEditingTP,
    isAddingNewPhase: state.trainingPrograms.isAddingNewPhase,
    isLoading: state.trainingPrograms.isLoading,
    selectedGuid: state.trainingPrograms.selectedTPGuid,
    selectedTP: tPsSelectors.selectedTP(state),
    userContext: state.common.userContext,
    formTypes: state.common.formTypes
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editTP: () => {
      return dispatch(trainingProgramsActionCreators.editTP());
    },
    setSelectedTPGuid: (trainingProgramGuid) => {
      return dispatch(trainingProgramsActionCreators.setSelectedTrainingProgramGuid(trainingProgramGuid));
    },
    updateTP: (trainingProgramGuid, formData) => {
      return dispatch(trainingProgramsActionCreators.updateTP(trainingProgramGuid, formData));
    },
    closeEditTP: () => {
      return dispatch(trainingProgramsActionCreators.closeEditTP());
    },
    addNewPhase: () => {
      return dispatch(trainingProgramsActionCreators.addNewPhase());
    },
    closeAddNewPhase: () => {
      return dispatch(trainingProgramsActionCreators.closeAddNewPhase());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrainingProgramDetail);
